import { render, staticRenderFns } from "./handover_list.vue?vue&type=template&id=75892cbe&scoped=true"
import script from "./handover_list.vue?vue&type=script&lang=js"
export * from "./handover_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75892cbe",
  null
  
)

export default component.exports